import apiUrl from '../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import download from 'downloadjs';

export default {
	name: 'BulkUploadSecondarySortConfiguration',
	components: {
		VueElementLoading,
		download
	},
	data: function() {
		return {
			createdBy:"",
			isLoadingUpload :false,
			fileDetails:[],
            selectedFile:{},
            configFile:'',
            failedEntries:[]
		}
	},
	created: function() {},
	computed: {},
	filters: {},
	mounted() {
		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext)
		this.createdBy = userdetail[0].email;
	},
	methods: {

	    secondarySortConfigUploadBulk(event){
            this.selectedFile = event.target[1].files[0];
            this.failedEntries = [];

            if(this.selectedFile.size>5242880){
                this.$alertify.error("Failed! Upload Max File Size Should Not Be Greater Than 5 MB"); 
                return false;
            }else if ( /\.(csv)$/i.test(this.selectedFile.name)){
                this.isLoadingUpload = true;

                const fd = new FormData();
                fd.append('lastModifiedBy', this.createdBy);
                fd.append('fileData', this.selectedFile);
                fd.append('fileName', this.selectedFile.name);

                axios.post(apiUrl.api_url_hubops + 'secondarySortConfigUploadBulk', fd,
                {
                    headers: {
                    'Authorization': 'authkey xB84JJ89Hd25'
                    }
                })
                .then(result => {

                    if(result.data.ResultCode == 100){
                        this.isLoadingUpload = false;
                        this.$alertify.success(result.data.ReturnMessage);
                        this.resetForm();
                    }else{
                        this.isLoadingUpload = false;
                        this.failedEntries = result.data.failedRows;
                        this.$alertify.error(result.data.ReturnMessage);
                    }
                    this.isLoadingUpload= false;
                }, error => {
                    console.error(error)
                    this.isLoadingUpload= false;
                    this.$alertify.error('Error Occured');
                });
            } else {
                this.isLoadingUpload= false;
                this.$alertify.error("Failed! Please Upload Only Valid Format: .csv");
            }
        },

        onUploadSubmit: function(result) {
            console.log(result);
            this.$validator.validateAll().then((result) => {
                if(result){
                    this.secondarySortConfigUploadBulk(event);
                    event.target.reset();
                }
            }).catch((err) => {
                console.log(err);
                this.$alertify.error('Error Occured');
            });
        },

        resetForm(event){
            this.isLoadingUpload = false;
            this.configFile= '';
            this.$validator.reset();
            this.errors.clear();
        }
	}
}



// WEBPACK FOOTER //
// ./src/views/components/BulkUploadSecondarySortConfiguration/BulkUploadSecondarySortConfiguration.js